import { getLocales } from 'expo-localization';
import { Platform } from 'react-native';
import { SUPPORTED_LANGUAGES } from '../../app.config.json';
import i18n from 'i18next';
import { env } from './env';
import { getWebWindow } from 'app/utils/web-window';
import { useSyncExternalStore } from 'react';

export const supportedLanguages = SUPPORTED_LANGUAGES as ('fr' | 'en' | 'es')[];
export type Language = (typeof supportedLanguages)[number];

export const DEFAULT_LANGUAGE = supportedLanguages[0]!;

export const languageLabels: Record<Language, string> = {
  en: 'English',
  fr: 'Français',
  es: 'Español',
};
export const DEFAULT_COUNTRY = env.IS_PARTAKE ? 'US' : 'CA';

export const getDeviceLanguage = () => {
  let deviceLanguage = DEFAULT_LANGUAGE;

  try {
    const deviceLocales = getLocales();

    const { languageCode } = deviceLocales[0];

    deviceLanguage = !supportedLanguages.includes(languageCode as Language)
      ? DEFAULT_LANGUAGE
      : (languageCode as Language);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {}
  return deviceLanguage;
};

export function getGuestWebLanguage({ isWeb, search }: { isWeb: boolean; search: string }): Language | undefined {
  if (!isWeb) return undefined;

  const language = new URLSearchParams(search).get('language');
  return supportedLanguages.includes(language as Language) ? (language as Language) : undefined;
}

export const getGuestWebLanguageFromLocation = () => {
  const window = getWebWindow();
  return getGuestWebLanguage({
    isWeb: Platform.OS === 'web',
    search: !window ? '' : window.location.search,
  });
};

export const getI18nLanguage = () => (i18n.resolvedLanguage?.substring(0, 2) ?? DEFAULT_LANGUAGE) as Language;

function subscribeToLanguage(onChange: () => void) {
  i18n.on('languageChanged', onChange);
  return () => {
    i18n.off('languageChanged', onChange);
  };
}

/** Reactive language snapshot for renders, including React Compiler builds. */
export function useI18nLanguage() {
  return useSyncExternalStore(subscribeToLanguage, getI18nLanguage, getI18nLanguage);
}
